import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './pages/login/login.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    CoreModule,
  ],
  declarations: [
    LoginComponent,
  ]
})
export class LoginModule { }
